
import { CommonSelect, CstmPagination } from 'components/Common/Common'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import CaseloadSchool from 'components/shared/caseLoad/CaseloadSchool'
import ErrorComponent from 'components/shared/ErrorComponent'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayoutV2 from 'components/TableLayoutV2'
import { TASK_CLIENT_TYPES, TASK_STATUS_OPTIONS_V2 } from 'config/constants'
import { CASELOAD_TASK } from 'config/paths'
import { dateFormat } from 'helpers/common'
import { usePersistentState } from 'hooks/usePersistentState'
import { debounce } from 'lodash'
import React, { useCallback, useState } from 'react'
import { Col, Container } from 'react-bootstrap'
import { Star } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useFavouriteTaskPlanMutation, useGetCaseloadDataQuery } from 'store/services/myCaseload'
import { useGetTaskPlanListQuery } from 'store/services/SupportStaff'
import { useUpdateTaskStatusMutation } from 'store/services/V2/TaskPlan'
import { taskPlanFilter } from 'store/slices/filter';

function MyCaseload() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [modalType, setModalType] = useState(null);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [newStatus, setNewStatus] = useState("");

  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = usePersistentState("taskplan:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.taskPlanFilter);

  const { data, isLoading, isError, isFetching, refetch } = useGetTaskPlanListQuery(
    { page: currentPage, limit: pageSize, ...filter },
    { refetchOnMountOrArgChange: true }
  );

  const { data: caseloadSchoolData, isLoading: caseloadSchoolLoading } = useGetCaseloadDataQuery()

  const taskPlanList = data?.records || [];
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [favouriteTaskPlan, { isLoading: favouriteTaskLoading }] = useFavouriteTaskPlanMutation()
  const [updateTaskStatus, { isLoading: statusLoading }] = useUpdateTaskStatusMutation()


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(taskPlanFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handleSearchChange = useCallback(debounce((value) => {
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const handleGetRowColor = (item) => {
    console.log("get row color calling")
    if (item?.status == "pending") {
      return "rowYellow";
    }
    else if (item?.status == "inactive") {
      return "rowGray";
    }
  }

  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteTaskPlan({ data, id }).unwrap()
    } catch (error) {
      console.error('error making the client favourite: ', error)
    }
    refetch()
  }

  const handleUpdateStatus = async () => {
    setIsStatusModal(false)
    try {

      const resp = await updateTaskStatus({
        id: currentEntry?.id,
        payload: {
          status: newStatus
        },
      });
      if (resp.data.status === "success") {
        successMessageToast(resp?.data?.message)
      }

    } catch (error) {
      console.error(error);
    }
  }


  const column = [
    {
      head: <div onClick={() => dispatch(taskPlanFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "id", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => {
          e.stopPropagation();
          handleFavouriteReport(item?.id, item?.is_favorite ? 0 : 1)
        }}>{item?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },


    {
      head: "DATE",
      accessor: "date",
      isComponent: true,
      sorter: true,
      component: (item) => dateFormat(item?.date, "MMM DD, YYYY"),
    },

    // {
    //   head: "DISC",
    //   accessor: "",
    //   component: (item, ind) => (
    //     <>
    //       <span className={`discipline-${user?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{user?.therapist_discipline?.assign_term}</span>
    //     </>
    //   ),
    // },

    {
      head: "PLAN NAME",
      accessor: "plan_name",
      isComponent: true,
      sorter: true,
      width: "100%",

    },

    {
      head: "CLIENT",
      accessor: "client_id",
      isComponent: true,
      sorter: true,
      width: "100%",
      component: (item) => {
        const clientName = `${item?.client?.client_detail?.lastname} ${item?.client?.client_detail?.firstname}`
        return (
          <div>
            <span>{clientName}</span>
          </div>
        )
      },


    },
    // {
    //     head: "CLIENT",
    //     accessor: "task_name",
    //     isComponent: true,
    //     sorter: true,
    //     width: "100%",
    //     component: (item, ind) => (
    //         <div className="d-flex align-items-center gap-10">
    //             <h6 className="m-0 fw-sbold" >
    //                 {item.tasks?.length
    //                     ? item.tasks.map((list) => list.task_name).join(", ")
    //                     : "-"}

    //             </h6>
    //         </div>
    //     ),
    // },

    {
      head: "GR.",
      accessor: "client_grade",
      isComponent: true,
      sorter: true,
      width: "100%",
    },
    {
      head: "Status",
      accessor: "status",
      isComponent: true,
      sorter: true,
    },

    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item, index) => (
    //     item?.status != "discharged" &&
    //     <Dropdown
    //       onClick={(e) => e.stopPropagation()}
    //     >
    //       <Dropdown.Toggle
    //         variant="transparent"
    //         className="p-0 border-0 text-dark w-100"
    //         id="dropdown-basic"
    //       >
    //         <ThreeDotsMenuIcon />
    //       </Dropdown.Toggle>
    //       <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
    //         <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
    //           <h5 onClick={(e) => {

    //             e.stopPropagation();
    //             navigate(TASK_PLAN_EDIT.replace(":id", item.id));
    //           }} className="cursor-pointer proxima">
    //             Edit
    //           </h5>

    //         </ul>
    //       </Dropdown.Menu>
    //     </Dropdown>
    //   ),
    // },
  ];
  return (
    <>
      <ConfirmationPop
        confirmation={isStatusModal}
        setConfirmation={setIsStatusModal}
        confirmHandler={handleUpdateStatus}
        type={modalType}
      />
      <section className='client position-relative py-4 px-2 min-vh-100' style={{ background: "#3DA0AA0D" }}>

        <Container fluid>
          {isLoading || caseloadSchoolLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> :
            <Col className='col-lg-10'>
              <CaseloadSchool caseloadData={caseloadSchoolData?.record} />
              {/* <div className='left classroom-conslutation d-flex justify-content-between align-items-end mt-4'>
                  <h6 className="m-0  fw-bold main-head themeBlue">My Tasks</h6>
                  <Col xs="4" md='4'>
                    <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0 w-100 text-end">Client Type</label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={TASK_CLIENT_TYPES}
                        onChange={(e) => handleFilterChange("client_type")(e)}
                        value={filter?.client_type}
                        isFilterV2
                        isClearable
                        // isLoading={schoolListLoading || schoolListFetching}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%", // ✅ Ensures the whole Select container is full width
                          }),
                        }}
                      />
                    </div>
                  </Col>
                  <Col xs="4" md='4'>
                    <div className="reports-v2 d-flex w-100 align-items-center gap-3">
                      <label className="discharge-screen-label mb-0 w-100 text-end">Status</label>
                      <CommonSelect
                        placeholder={"Select"}
                        option={TASK_STATUS_OPTIONS_V2}
                        onChange={(e) => handleFilterChange("status")(e)}
                        value={filter?.status}
                        isFilterV2
                        isClearable
                        // isLoading={schoolListLoading || schoolListFetching}
                        styles={{
                          container: (provided) => ({
                            ...provided,
                            width: "100%", // ✅ Ensures the whole Select container is full width
                          }),
                        }}
                      />
                    </div>
                  </Col>
                </div> */}
              <div className="classroom-conslutation d-flex justify-content-between align-items-center mt-4">
                {/* Left Side */}
                <h6 className="m-0 fw-bold main-head themeBlue">
                  My Tasks
                </h6>

                {/* Right Side */}
                <div className="d-flex align-items-center gap-3">
                  <div style={{ width: "250px" }} >
                    <div className="reports-v2 d-flex align-items-center gap-3">
                      <label style={{width: "35%"}} className="discharge-screen-label  mb-0 text-end">
                        Client Type
                      </label>
                      <CommonSelect
                        placeholder="Select"
                        option={TASK_CLIENT_TYPES}
                        onChange={(e) => handleFilterChange("client_type")(e)}
                        value={filter?.client_type}
                        isFilterV2
                        className='w-100'
                        isClearable
                      />
                    </div>
                  </div>

                  <div style={{ width: "250px" }}>
                    <div className="reports-v2 d-flex align-items-center gap-3">
                      <label className="discharge-screen-label mb-0 text-end">
                        Status
                      </label>
                      <CommonSelect
                        placeholder="Select"
                        option={TASK_STATUS_OPTIONS_V2}
                        onChange={(e) => handleFilterChange("status")(e)}
                        value={filter?.status}
                        isFilterV2
                        className='w-100'
                        isClearable
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-outer mt-3">

                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || favouriteTaskLoading || statusLoading) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={taskPlanList}
                      column={column}
                      filter={filter}
                      // url={CASELOAD_TASK.replace("/:id", "")}

                      handleRowClick={(row) => {
                        navigate(
                          CASELOAD_TASK.replace(
                            "/:taskPlanId/:clientId",
                            `/${row?.id}/${row?.client_id}`
                          )
                        );
                      }}
                      handleSort={handleFilterChange("sort")}
                      handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>

            </Col>
          }
        </Container>
      </section >
    </>
  )
}

export default MyCaseload
